export const PLAYSTORE_URL: string =
  "https://play.google.com/store/apps/details?id=no.digipost.android";
export const APPSTORE_URL: string =
  "https://itunes.apple.com/no/app/digipost/id441997544";
